<section appLazyViewport (inViewport)="loadProducts()" class="design-products" [class.design-products--curated]="curated">
  <app-home-popularproducts
    [popularProduct]="products"
    [wishlistIds]="wishlistIds"
    [titleKey]="curated ? 'home.design.curated_title' : 'home.design.title'"
    [showTitle]="false"
    [showViewAll]="false"
    [showCustomizationBadge]="false"
    [showMoqBadge]="true"
    [stackHeaderOnMobile]="true"
    [mobileGrid]="curated"
    [loading]="loading"
    [emptyMessageKey]="error ? '' : 'home.design.empty'"
    (wishlistChanged)="wishlistChanged.emit()">
    <h2 product-filter *ngIf="curated" class="design-products__curated-title">
      {{ 'home.design.curated_title' | translate }}
    </h2>
    <div product-filter *ngIf="!curated" class="design-products__header">
    <div class="design-products__toolbar">
      <h2 class="design-products__connector-title">{{ 'home.design.connector_title' | translate }}</h2>

      <div class="design-products__filter" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="design-products__trigger"
          [class.is-open]="isOpen"
          (click)="toggleDropdown($event)"
          [attr.aria-expanded]="isOpen"
          aria-haspopup="listbox"
          [attr.aria-label]="('home.design.min_quantity' | translate) + ': ' + (selectedOption.labelKey | translate)">
          <span class="design-products__trigger-label">
            <span class="design-products__label-full">{{ 'home.design.min_quantity' | translate }}:</span>
            <span class="design-products__label-short">{{ 'home.design.min_quantity_short' | translate }}:</span>
            <strong class="design-products__selected-text">{{ selectedOption.labelKey | translate }}</strong>
          </span>
          <span class="material-symbols-outlined design-products__chevron" [class.is-rotated]="isOpen" aria-hidden="true">
            expand_more
          </span>
        </button>

        <div
          *ngIf="isOpen"
          class="design-products__dropdown"
          role="listbox"
          [attr.aria-label]="'home.design.min_quantity' | translate">
          <div class="design-products__dropdown-header">
            {{ 'home.design.moq_dropdown_header' | translate }}
          </div>
          <div class="design-products__dropdown-list">
            <button
              *ngFor="let opt of moqOptions"
              type="button"
              role="option"
              [attr.aria-selected]="minQuantity === opt.value"
              class="design-products__option"
              [class.is-selected]="minQuantity === opt.value"
              (click)="selectOption(opt)">
              <div class="design-products__option-info">
                <div class="design-products__option-top">
                  <span class="design-products__option-label">{{ opt.labelKey | translate }}</span>
                  <span *ngIf="opt.badgeKey" class="design-products__option-badge" [class.is-single]="opt.value === 1">
                    {{ opt.badgeKey | translate }}
                  </span>
                </div>
              </div>
              <span
                *ngIf="minQuantity === opt.value"
                class="material-symbols-outlined design-products__check-icon"
                aria-hidden="true">
                check
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="design-products__search">
      <span class="material-symbols-outlined" aria-hidden="true">search</span>
      <input #searchInput type="search"
        [value]="search"
        (input)="changeSearch(searchInput.value)"
        [placeholder]="'home.design.search_placeholder' | translate"
        [attr.aria-label]="'home.design.search_placeholder' | translate" />
    </div>
    </div>
    <div product-status *ngIf="error">
      <app-section-error (retry)="retry()"></app-section-error>
    </div>
  </app-home-popularproducts>
  <mat-paginator
    class="design-products__paginator"
    *ngIf="!curated && totalCount > 0"
    [length]="totalCount"
    [pageIndex]="pageIndex"
    [pageSize]="18"
    [hidePageSize]="true"
    [showFirstLastButtons]="true"
    [disabled]="loading"
    (page)="changePage($event.pageIndex)">
  </mat-paginator>
</section>
